import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { FormBuilder, FormGroup, ValidatorFn, Validators } from '@angular/forms';
import { debounceTime, Subject } from 'rxjs';
import { PaisDto } from '../../../dto/expediente/pais.dto';
import { DepartmentoDto } from '../../../dto/expediente/departmento.dto';
import { ListasService } from '../../../services/listas.service';
import { MunicipioDto } from '../../../dto/expediente/municipio.dto';
import { TipoPersonaDto } from '../../../dto/expediente/tipo-persona-dto.dto';
import { Constants } from '../../../constants/constants';
import { TipoDocumentoDto } from '../../../dto/expediente/tipo-documento.dto';
import { dominioValidador } from '../../util/validadores/validador-dominio';
import { PersonaLoginDTO } from '../../../dto/util/persona.dto';
import { TranslateService } from '@ngx-translate/core';
import { TextTransformService } from '../../util/text-transform/text-transform.service';
import { ConfigurarCuentasService } from '../../configuracion-cuenta/services/configurar-cuentas.service';

@Component({
  selector: 'app-persona',
  templateUrl: './persona.component.html',
  styleUrl: './persona.component.scss',
})
export class PersonaComponent implements OnInit, OnChanges {
  personForm: FormGroup = new FormGroup({});

  // Objeto para almacenar el estado de autocompletado de los campos
  autocompletedFields: { [key: string]: boolean } = {};

  private formChanges = new Subject<void>();
  constants = Constants;
  validationMessage = '';
  validationMessageMin = '';
  validationMessagePattern = '';

  // Multilenguaje
  personaText: any = {};
  comunText: any = {};

  esTipoDocIndocumentado = false;

  constructor(
    private readonly fb: FormBuilder,
    private readonly listService: ListasService,
    private readonly translate: TranslateService,
    private readonly textTransformService: TextTransformService,
    private readonly _cuentaService: ConfigurarCuentasService
  ) {
    this.buildForm();
  }
  tipoDePersonaList: TipoPersonaDto[] = [];
  isNaturalPerson: boolean | undefined = undefined;
  selectedOption = '';
  departments: DepartmentoDto[] = [];
  municipalities: MunicipioDto[] = [];
  hideDepartment = false;
  hideMunicipality = false;

  @Input() countries: PaisDto[] = [];
  @Input() documentTypeList: TipoDocumentoDto[] = [];
  @Input() documentTypeListInteresada: TipoDocumentoDto[] = [];
  @Input() documentTypeListApoderado: TipoDocumentoDto[] = [];
  @Input() documentTypeListJuridica: TipoDocumentoDto[] = [];
  @Input() personTypeLabel = '';
  @Input() showTypePerson = false;
  @Output() formData = new EventEmitter<{ valid: boolean; data: any }>();
  @Input() dataLogin!: PersonaLoginDTO | undefined;
  @Input() isDimar = false;
  @Input() autocompleted = true;
  @Input() values: any;
  @Input() isApoderado = false;
  @Input() isParteInteresada = false;
  @Input() esRepresentante = false;
  @Input() aditionalText = '';
  @Input() showAditionalText = false;
  buildForm() {
    this.personForm = this.fb.group({
      tipoDePersona: ['', [Validators.required]],
      email: [
        '',
        [
          Validators.required,
          Validators.pattern(Constants.REGEX_CORREO_ELECTRONICO),
          dominioValidador(),
          Validators.maxLength(100),
        ],
      ],
      primerNombre: [
        '',
        [
          Validators.required,
          Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_PLAIN_TEXT),
          Validators.minLength(2)
        ],
      ],
      segundoNombre: [
        '',
        [Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_PLAIN_TEXT),
        Validators.minLength(2)
        ],
      ],
      primerApellido: [
        '',
        [
          Validators.required,
          Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_PLAIN_TEXT),
          Validators.minLength(2)
        ],
      ],
      segundoApellido: [
        '',
        [Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_PLAIN_TEXT),
        Validators.minLength(2)]
      ],
      tipoDocumento: ['', Validators.required],
      identificacion: [
        {
          value: '',
          disabled: true,
        },
        [Validators.required],
      ],
      pais: ['', [Validators.required]],
      departmento: ['', [Validators.required]],
      municipio: ['', [Validators.required]],
      otroDepartamento: [''],
      otroMunicipio: [''],
      direccion: [
        '',
        [
          Validators.required,
          Validators.pattern(
            Constants.REGEX_ALPHANUMERIC_WITHOUT_SPACES_ADDRESS
          ),
          Validators.maxLength(40),
          Validators.minLength(10),
        ],
      ],
    });
  }

  ngOnInit() {
    // if (this.esRepresentante) {
    //   this.personForm.get('primerNombre')?.markAsDirty();
    //   this.personForm.get('primerNombre')?.markAllAsTouched();
    //   this.personForm.get('primerApellido')?.markAsDirty();
    //   this.personForm.get('primerApellido')?.markAllAsTouched();
    // }
    this.formChanges.pipe(debounceTime(300)).subscribe(() => {
      this.emitFormData();
    });

    // Detecta cambios en el formulario
    this.personForm.valueChanges.subscribe(() => {
      this.formChanges.next();
      this.checkAutocomplete();
    });
    this.personForm.get('tipoDocumento')?.valueChanges.subscribe(type => {
      this.updateIdentificationValidators(type);
    });
    if (!this.showTypePerson) {
      this.isNaturalPerson = true;
      this.personForm?.patchValue({
        tipoDePersona: Constants.TYPE_OF_PERSON_NATURAL,
      });
    }
    this.loadListtipoDePersona();
    const user_type = JSON.parse(
      sessionStorage.getItem(Constants.USER_TYPE) ?? '{}');
    if (this.isDimar) {
      setTimeout(() => {
        if (this.dataLogin !== undefined) {
          if (user_type.Nombre === 'Ciudadano') {
            this.setValuesPersonFormDIMAR(this.dataLogin);
          }
        }
      }, 1000);
    } else {
      setTimeout(() => {
        if (this.dataLogin !== undefined) {
          if (this.isApoderado && user_type.Nombre === 'Abogado') {
            this.setValuesApoderado(this.dataLogin);
          } else {
            if (user_type.Nombre === 'Ciudadano') {
              this.setValuesPersonFormDNDA(this.dataLogin);
            }
          }
        }
      }, 1500);
    }

    if (this.values !== undefined) {
      Object.keys(this.values).forEach(key => {
        if (key === 'tipoDePersona') {
          if (this.values[key] === 1) {
            this.isNaturalPerson = true;
          } else if (this.values[key] === 2) {
            this.isNaturalPerson = false;
          }
        }

        if (key === 'pais') {
          this.onChangeCountry({ target: { value: this.values[key] } }, true);
        }

        this.personForm?.get(key)?.setValue(this.values[key]);
        this.personForm?.get(key)?.updateValueAndValidity();
      });
    }

    this.translate.stream('tramites').forEach(text => {
      for (const key of Object.keys(text)) {
        this.personaText[key] = text[key];
      }
    });
    this.translate.stream('comun-label').forEach(text => {
      for (const key of Object.keys(text)) {
        this.comunText[key] = text[key];
      }
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    const user_type = JSON.parse(
      sessionStorage.getItem(Constants.USER_TYPE) ?? '{}');
    if (this.isDimar) {
      setTimeout(() => {
        if (this.dataLogin !== undefined) {
          if (user_type.Nombre === 'Ciudadano') {
            this.setValuesPersonFormDIMAR(this.dataLogin);
          }
        }
      }, 1000);
    } else {
      setTimeout(() => {
        if (this.dataLogin !== undefined) {
          if (this.isApoderado && user_type.Nombre === 'Abogado') {
            this.setValuesApoderado(this.dataLogin);
          } else {
            if (user_type.Nombre === 'Ciudadano') {
              this.setValuesPersonFormDNDA(this.dataLogin);
            }
          }
        }
        setTimeout(() => {
          this.emitFormData();
        }, 1500);
      }, 1500);
    }

    if (changes['values'] && changes['values'].currentValue) {
      Object.keys(changes['values'].currentValue).forEach(key => {
        if (
          changes['values'].previousValue &&
          changes['values'].currentValue[key] ===
          changes['values'].previousValue[key]
        ) {
          return;
        }
        if (key === 'tipoDePersona') {
          if (changes['values'].currentValue[key] === 1) {
            const firstLastNameControl = this.personForm.get('primerApellido');
            firstLastNameControl?.setValidators([
              Validators.required,
              Validators.minLength(2),
              Validators.pattern(
                Constants.REGEX_STRING_WITHOUT_SPACES_PLAIN_TEXT
              ),
            ]);
            this.isNaturalPerson = true;
          } else if (changes['values'].currentValue[key] === 2) {
            const firstLastNameControl = this.personForm.get('primerApellido');
            firstLastNameControl?.clearValidators();
            firstLastNameControl;
            this.isNaturalPerson = false;
          }
        }

        if (key === 'pais') {
          if (changes['values'].currentValue[key] != null) {
            this.onChangeCountry(
              { target: { value: changes['values'].currentValue[key] } },
              true
            );
            setTimeout(() => {
              const deptValue = changes['values'].currentValue['departmento'];
              if (deptValue != null && deptValue !== '') {
                this.personForm.get(Constants.DEPARTMENT_CAMPO)?.setValue(deptValue);
                this.personForm.get(Constants.DEPARTMENT_CAMPO)?.updateValueAndValidity();
                this.onChangeDepartment(
                  { target: { value: deptValue } },
                  true
                );

                setTimeout(() => {
                  const munValue = changes['values'].currentValue['municipio'];
                  if (munValue != null && munValue !== '') {
                    this.personForm.get(Constants.MUNICIPALITY_CAMPO)?.setValue(munValue);
                    this.personForm.get(Constants.MUNICIPALITY_CAMPO)?.updateValueAndValidity();
                  } else {
                    this.personForm.get(Constants.MUNICIPALITY_CAMPO)?.setValue(null);
                    this.personForm.get(Constants.MUNICIPALITY_CAMPO)?.updateValueAndValidity();
                  }
                }, Constants.MUNICIPALITY_TIEMPO);
              } else {
                this.personForm.get(Constants.MUNICIPALITY_CAMPO)?.setValue(null);
                this.personForm.get(Constants.MUNICIPALITY_CAMPO)?.updateValueAndValidity();
              }
            }, Constants.DEPARTEMENT_TIEMPO);
          }
        }

        if (key !== 'municipio') {
          this.personForm
            ?.get(key)
            ?.setValue(changes['values'].currentValue[key]);
          this.personForm?.get(key)?.updateValueAndValidity();
        }

        this.personForm
          ?.get(key)
          ?.setValue(changes['values'].currentValue[key]);
        this.personForm?.get(key)?.updateValueAndValidity();
      });
    }
  }


  emitFormData() {
    this.formData.emit({
      valid: this.personForm.valid,
      data: this.personForm.value,
    });
  }

  onTypePersonChange(event: any) {
    this.esTipoDocIndocumentado = false;
    this.personForm.get('identificacion')?.setValidators(Validators.required);
    this.personForm.get('identificacion')?.updateValueAndValidity();
    const firstLastNameControl = this.personForm.get('primerApellido');
    const documentType = this.personForm.get('tipoDocumento');
    if (event.target.value === Constants.TYPE_OF_PERSON_NATURAL) {
      this.isNaturalPerson = true;
      firstLastNameControl?.setValidators([
        Validators.required,
        Validators.minLength(2),
        Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_PLAIN_TEXT),
      ]);
      documentType?.setValidators([Validators.required]);
    } else {
      const razonSocial = this.personForm.get('primerNombre');
      this.isNaturalPerson = false;
      firstLastNameControl?.clearValidators();
      documentType?.clearValidators();
      this.personForm?.patchValue({ tipoDocumento: Constants.NIT_ID });
      razonSocial?.setValidators([
        Validators.required,
        Validators.pattern(Constants.REGEX_ALPHANUMERIC_RAZON_SOCIAL),
      ]);
      if (this.isDimar) {
        if (this.dataLogin) {
          if (this.dataLogin?.tipoPersona === event.target.value) {
            this.setValuesPersonFormDIMAR(this.dataLogin);
          } else {
            this.personForm.get('email')?.setValue(null);
            this.personForm.get('identificacion')?.setValue(null);
            this.personForm.get('primerNombre')?.setValue(null);
            this.personForm.get('primerApellido')?.setValue(null);
            this.personForm.get('segundoNombre')?.setValue(null);
            this.personForm.get('segundoApellido')?.setValue(null);
            this.personForm.get('pais')?.setValue(null);
            this.personForm.get('departmento')?.setValue(null);
            this.personForm.get('municipio')?.setValue(null);
            this.personForm.get('direccion')?.setValue(null);
            this.personForm.get('otroDepartamento')?.setValue(null);
            this.personForm.get('otroMunicipio')?.setValue(null);
            this.departments = [];
            this.municipalities = [];
          }
        }
      }
    }

    firstLastNameControl?.updateValueAndValidity();
    documentType?.updateValueAndValidity();
  }

  onChangeCountry(event: any, preload?: boolean) {
    if (event.target.value != '') {
      this.listService
        .getDepartmentList(event.target.value)
        .subscribe(departments => {
          this.departments = departments;
          this.personForm.get('municipio')?.setValue('');
          this.municipalities = [];
          const selectedCountry = this.countries.find(
            country => country.Id === +event.target.value
          );
          if (selectedCountry?.Codigo !== 'CO') {
            this.personForm.get('departmento')?.setValue(this.departments?.[0]?.Id);
            this.personForm.get('departmento')?.clearValidators();
            this.personForm.get('departmento')?.updateValueAndValidity();
            this.onChangeDepartment(null, false, this.departments?.[0]?.Id);
            this.personForm.get('otroDepartamento')?.setValue('');
            this.personForm.get('otroDepartamento')?.setValidators([
              Validators.required,
              Validators.maxLength(30),
              Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_WITH_ACCENTS)
            ]);
            this.personForm.get('otroDepartamento')?.updateValueAndValidity();
            this.personForm.get('otroMunicipio')?.setValue('');
            this.personForm.get('otroMunicipio')?.setValidators([
              Validators.required,
              Validators.maxLength(30),
              Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_WITH_ACCENTS)
            ]);
            this.personForm.get('otroMunicipio')?.updateValueAndValidity();
            // this.onChangeDepartment({
            //   target: { value: this.departments[0]?.Id },
            // });
            this.onChangeDepartment({
              target: { value: '' },
            });
            this.hideDepartment = true;
            this.hideMunicipality = true;
            this.emitFormData();
          } else {
            this.hideDepartment = false;
            this.hideMunicipality = false;
            this.personForm.get('departmento')?.setValue('');
            this.personForm.get('otroDepartamento')?.setValue('');
            this.personForm.get('otroMunicipio')?.setValue('');
            this.personForm.get('municipio')?.setValue('');
            this.personForm.get('departmento')?.setValidators([Validators.required]);
            this.personForm.get('municipio')?.setValidators([Validators.required]);
            this.personForm.get('otroDepartamento')?.clearValidators();
            this.personForm.get('otroMunicipio')?.clearValidators();
            this.personForm.get('departmento')?.updateValueAndValidity();
            this.personForm.get('municipio')?.updateValueAndValidity();
            this.personForm.get('otroDepartamento')?.updateValueAndValidity();
            this.personForm.get('otroMunicipio')?.updateValueAndValidity();
          }
          if (preload) {
            if (selectedCountry?.Codigo !== 'CO') {
              this.personForm.get('departmento')?.clearValidators();
              this.personForm.get('departmento')?.updateValueAndValidity();
              this.personForm.get('municipio')?.clearValidators();
              this.personForm.get('municipio')?.updateValueAndValidity();
              this.personForm.get('otroDepartamento')?.setValue(this.values['otroDepartamento']);
              this.personForm.get('otroMunicipio')?.setValue(this.values['otroMunicipio']);
              this.personForm.get('otroDepartamento')?.updateValueAndValidity();
              this.personForm.get('otroMunicipio')?.updateValueAndValidity();
            } else {
              this.personForm.get('otroDepartamento')?.clearValidators();
              this.personForm.get('otroMunicipio')?.clearValidators();
              this.personForm.get('otroDepartamento')?.updateValueAndValidity();
              this.personForm.get('otroMunicipio')?.updateValueAndValidity();
              this.personForm?.get('departmento')?.setValue(this.values['departmento']);

              if (this.personForm?.get('pais')?.value == 1) {
                this.onChangeDepartment({ target: { value: this.values['departmento'] } }, true);
              }
              this.personForm.get('departmento')?.updateValueAndValidity();
            }
          }
        });
    } else {
      this.personForm.get('departmento')?.setValue('');
      this.personForm.get('municipio')?.setValue('');
      this.personForm.get('otroDepartamento')?.setValue('');
      this.personForm.get('otroMunicipio')?.setValue('');
      this.personForm.get('departmento')?.updateValueAndValidity();
      this.personForm.get('municipio')?.updateValueAndValidity();
      this.personForm.get('otroDepartamento')?.updateValueAndValidity();
      this.personForm.get('otroMunicipio')?.updateValueAndValidity();
    }
  }
  onChangeDepartment(event: any, preload?: boolean, idDepartamento: number | undefined = undefined) {
    if (event?.target?.value != '' || idDepartamento) {
      const departamento =
        event?.target?.value && event?.target?.value != ''
          ? event?.target?.value
          : idDepartamento;
      this.listService
        .getMunicipalityList(departamento)
        .subscribe(municipalities => {
          this.municipalities = municipalities;
          const selectedCountry = this.countries.find(
            country => country.Id === +this.personForm.get('pais')?.value
          );
          if (selectedCountry?.Codigo !== 'CO') {
            /** Se limpia opciones de municipio
             *           this.personForm
              .get('municipio')
              ?.setValue(this.municipalities[0]?.Id);
             *
             */
            this.personForm.get('municipio')?.setValue(this.municipalities?.[0].Id);
            this.personForm.get('municipio')?.updateValueAndValidity();
            this.hideMunicipality = true;
            this.emitFormData();
          } else {
            this.hideMunicipality = false;
            this.personForm.get('municipio')?.setValue('');
            this.personForm.get('municipio')?.updateValueAndValidity();
          }
          if (preload) {
            if (this.personForm.get('departmento')?.value) {
              if (selectedCountry?.Codigo !== 'CO') {
                this.personForm?.get('municipio')?.setValue('');
              } else {
                this.personForm
                  ?.get('municipio')
                  ?.setValue(this.values['municipio']);
              }
            } else {
              this.personForm?.get('municipio')?.setValue('');
            }
            this.personForm.get('municipio')?.updateValueAndValidity();
          }
        });
    } else {
      this.personForm.get('departmento')?.setValue('');
      this.personForm.get('municipio')?.setValue('');
      this.personForm.get('departmento')?.updateValueAndValidity();
      this.personForm.get('municipio')?.updateValueAndValidity();
    }
  }

  handlerDireccionUrbana(event: any) {
    this.personForm.patchValue({ direccion: event });
  }

  loadListtipoDePersona() {
    this.listService.getTipoDePersonaList().subscribe(tipoDePersonaList => {
      this.tipoDePersonaList = tipoDePersonaList;
    });
  }

  updateIdentificationValidators(type: number) {
    const indentificationControl = this.personForm.get('identificacion');
    indentificationControl?.enable();

    let validadoresIdentificacion: ValidatorFn[] = [];

    if (+this.personForm.get('tipoDePersona')?.value === 1) {
      if (+type === Constants.CEDULA_ID || +type === 2 ||
        +type === Constants.TARJETA_PROFESIONAL_ID) {
        validadoresIdentificacion = [
          Validators.required,
          Validators.minLength(4),
          Validators.maxLength(12),
          Validators.pattern(/^\d+$/), // Solo números
        ]
        indentificationControl?.setValidators(validadoresIdentificacion);
        this.validationMessageMin =
          this.personaText['CC-maxlength'];
        this.validationMessage =
          this.personaText['CC-maxlength'];
        this.validationMessagePattern =
          this.personaText['CC-pattern'];
      } else if (+type === Constants.FOREIGNER_ID) {
        validadoresIdentificacion = [
          Validators.required,
          Validators.minLength(4),
          Validators.maxLength(8),
          Validators.pattern(/^[a-zA-Z0-9]+$/), // Letras y números
        ];
        indentificationControl?.setValidators(validadoresIdentificacion);
        this.validationMessageMin =
          this.personaText['CC-maxlength'];
        this.validationMessage =
          this.personaText['CE-maxlength'];
        this.validationMessagePattern =
          this.personaText['CE-pattern'];
      }
    } else {
      validadoresIdentificacion = [
        Validators.required,
        Validators.minLength(4),
        Validators.maxLength(9),
        Validators.pattern(/^\d+$/),
      ];
      this.validationMessageMin =
        this.personaText['otro-minlength'];
      this.validationMessage =
        this.personaText['otro-maxlength'];
      this.validationMessagePattern =
        this.personaText['otro-pattern'];
      indentificationControl?.setValidators(validadoresIdentificacion);
    }
    this.validarEsIndocumentadoDirecto(type, validadoresIdentificacion);
    indentificationControl?.updateValueAndValidity();
  }

  setValuesPersonFormDNDA(data: PersonaLoginDTO) {
    if (this.autocompleted) {
      data = this.textTransformService.transformarAMayusculas(data);
      if (data.tipoPersona == Constants.TIPO_PERSONA.NATURAL) {
        this.personForm
          .get('tipoDocumento')
          ?.setValue(this.getIdTipoDocumento(1, String(data.tipoDocumento)));
        this.isNaturalPerson = true;
        this.personForm.get('tipoDePersona')?.setValue('1');
        this.personForm.get('primerNombre')?.setValue(data.primerNombre);
        this.personForm.get('segundoNombre')?.setValue(data.segundoNombre);
        this.personForm.get('primerApellido')?.setValue(data.primerApellido);
        this.personForm.get('segundoApellido')?.setValue(data.segundoApellido);
        this.updateIdentificationValidators(
          this.personForm.get('tipoDocumento')?.value
        );
      } else {
        this.personForm
          .get('tipoDocumento')
          ?.setValue(this.getIdTipoDocumento(2, String(data.tipoDocumento)));
        this.isNaturalPerson = false;
        this.personForm.get('tipoDePersona')?.setValue('2');
        this.personForm.get('primerNombre')?.setValue(data.razonSocial);
        this.updateIdentificationValidators(
          this.personForm.get('tipoDocumento')?.value
        );
      }
      this.setDataComun(data);
    }
  }

  setValuesApoderado(data: PersonaLoginDTO) {
    let tipoDocumento: number = 0;
    switch (data.tipoDocumento) {
      case 'CC':
        tipoDocumento = 1;
        break;
      case 'CE':
        tipoDocumento = 2;
        break;
      case 'Pasaporte':
        tipoDocumento = 4;
        break;
    }
    data = this.textTransformService.transformarAMayusculas(data);
    this.personForm.get('tipoDocumento')?.setValue(tipoDocumento);
    this.personForm.get('tipoDePersona')?.setValue('1');
    this.personForm.get('primerNombre')?.setValue(data.primerNombre);
    this.personForm.get('segundoNombre')?.setValue(data.segundoNombre);
    this.personForm.get('primerApellido')?.setValue(data.primerApellido);
    this.personForm.get('segundoApellido')?.setValue(data.segundoApellido);
    this.updateIdentificationValidators(
      this.personForm.get('tipoDocumento')?.value
    );
    this.setDataComun(data);
  }

  setDataComun(data: PersonaLoginDTO) {
    data = this.textTransformService.transformarAMayusculas(data);
    this.personForm.get('identificacion')?.setValue(data.identificacion);
    this.personForm.get('email')?.setValue(data.correoElectronico);
    data.direccion?.forEach(
      (elemento: {
        Direccion_Notificacion?: string;
        Es_Primaria?: boolean;
        Id?: number;
      }) => {
        if (elemento.Es_Primaria) {
          this.personForm
            .get('direccion')
            ?.setValue(elemento.Direccion_Notificacion);
        }
      }
    );
    if (data.pais) {
      this.getUbicacion(data);
    }
  }

  setValuesPersonFormDIMAR(data: PersonaLoginDTO) {
    data = this.textTransformService.transformarAMayusculas(data);
    if (data.tipoPersona == Constants.TIPO_PERSONA.NATURAL) {
      this.isNaturalPerson = true;
      this.personForm
        .get('tipoDocumento')
        ?.setValue(this.getIdTipoDocumento(1, String(data.tipoDocumento)));
      this.personForm.get('tipoDePersona')?.setValue(data.tipoPersona);
      this.personForm.get('primerNombre')?.setValue(data.primerNombre);
      this.personForm.get('segundoNombre')?.setValue(data.segundoNombre);
      this.personForm.get('primerApellido')?.setValue(data.primerApellido);
      this.personForm.get('segundoApellido')?.setValue(data.segundoApellido);

      this.personForm.get('identificacion')?.setValue(data.identificacion);
      this.personForm.get('email')?.setValidators([
        Validators.required,
        Validators.pattern(Constants.REGEX_CORREO_ELECTRONICO),
        dominioValidador(),
        Validators.maxLength(50),
      ],);
      this.personForm.get('email')?.setValue(data.correoElectronico);
      data.direccion?.forEach(
        (elemento: {
          Direccion_Notificacion?: string;
          Es_Primaria?: boolean;
          Id?: number;
        }) => {
          if (elemento.Es_Primaria) {
            this.personForm
              .get('direccion')
              ?.setValue(elemento.Direccion_Notificacion);
          }
        }
      );
      this.updateIdentificationValidators(
        this.personForm.get('tipoDocumento')?.value
      );
      if (data.pais) {
        this.getUbicacion(data);
      }
      this.personForm.get('direccion')?.markAsDirty();
      this.personForm.get('direccion')?.markAllAsTouched();
    } else {
      this.isNaturalPerson = false;
      this.personForm.get('identificacion')?.setValue(data.identificacion);
      this.personForm.get('email')?.setValidators([
        Validators.required,
        Validators.pattern(Constants.REGEX_CORREO_ELECTRONICO),
        dominioValidador(),
        Validators.maxLength(50),
      ],);
      this.personForm.get('email')?.setValue(data.correoElectronico);
      data.direccion?.forEach(
        (elemento: {
          Direccion_Notificacion?: string;
          Es_Primaria?: boolean;
          Id?: number;
        }) => {
          if (elemento.Es_Primaria) {
            this.personForm
              .get('direccion')
              ?.setValue(elemento.Direccion_Notificacion);
          }
        }
      );
      if (data.pais) {
        this.getUbicacion(data);
      }
      this.updateIdentificationValidators(
        this.personForm.get('tipoDocumento')?.value
      );
    }
  }

  getIdTipoDocumento(tipoPersona: number, nombre: string): number | undefined {
    if (tipoPersona === Constants.TIPO_PERSONA.NATURAL) {
      for (const elemento of this.documentTypeList) {
        if (elemento.Tipo_Documento === nombre) {
          return elemento.Id;
        }
      }
    } else {
      for (const elemento of this.documentTypeListJuridica) {
        if (elemento.Tipo_Documento === nombre) {
          return elemento.Id;
        }
      }
    }
    return undefined;
  }

  getUbicacion(data: PersonaLoginDTO) {
    this.personForm.get('pais')?.setValue(data.pais);
    if (data.pais == 1) {
      this.listService.getDepartmentList(data.pais).subscribe(departments => {
        this.departments = departments;
      });
      this.listService
        .getMunicipalityList(data.departamento)
        .subscribe(municipalities => {
          this.municipalities = municipalities;
        });
      setTimeout(() => {
        this.personForm.get('departmento')?.setValue(data.departamento);
        this.personForm.get('municipio')?.setValue(data.municipio);
      }, 1000);
    } else {
      setTimeout(() => {
        this.onChangeCountry({ target: { value: data.pais } }, false);
        this._cuentaService.getDataPersonal(+this.dataLogin!.idUsuario!).subscribe(
          (response: any) => {
            this.personForm.get('otroDepartamento')?.setValue(response.data.Otro_Departamento);
            this.personForm.get('otroMunicipio')?.setValue(response.data.Otro_Municipio);
          }
        );
      }, 400);


    }

  }

  // Método para verificar si los campos están autocompletados
  checkAutocomplete(): void {
    Object.keys(this.personForm.controls).forEach(fieldName => {
      const control = this.personForm.get(fieldName);
      if (control?.value && !control?.touched) {
        this.autocompletedFields[fieldName] = true;
      }
    });
  }

  // Verificar si un campo está marcado como autocompletado
  isAutocompleted(fieldName: string): boolean {
    return this.autocompletedFields[fieldName];
  }

  // Quitar el sombreado cuando el campo está en edición
  onFocus(fieldName: string): void {
    this.autocompletedFields[fieldName] = false;
  }

  validarEsIndocumentado(event: Event) {
    const selectedId = +(event.target as HTMLSelectElement).value;

    const documentoSeleccionado = this.documentTypeList.find(
      item => item.Id === selectedId
    );

    this.esTipoDocIndocumentado = documentoSeleccionado?.Tipo_Documento === 'NA'

    if (this.esTipoDocIndocumentado) {
      this.personForm.get('identificacion')?.clearValidators();
      this.personForm.get('identificacion')?.setValue('');
      this.personForm.get('identificacion')?.updateValueAndValidity();
    } else {
      this.personForm.get('identificacion')?.setValidators(Validators.required);
      this.personForm.get('identificacion')?.updateValueAndValidity();
    }
  }

  validarEsIndocumentadoDirecto(selectedId: number | string, validadoresPrevios: ValidatorFn[]) {
    const documentoSeleccionado = this.documentTypeList.find(
      item => item.Id === selectedId
    );

    this.esTipoDocIndocumentado = documentoSeleccionado?.Tipo_Documento === 'NA'

    if (this.esTipoDocIndocumentado) {
      this.personForm.get('identificacion')?.clearValidators();
      this.personForm.get('identificacion')?.setValue('');
      this.personForm.get('identificacion')?.updateValueAndValidity();
    } else {
      this.personForm.get('identificacion')?.setValidators(validadoresPrevios);
      this.personForm.get('identificacion')?.updateValueAndValidity();
    }
  }

  marcarTodoComoTocado(): void {
    this.personForm.markAllAsTouched();

  }

  get isButtonEnabled(): boolean {
    return this.personForm.valid;
  }
}
